// extracted by mini-css-extract-plugin
export default {"input":"ypa-z","button":"zpa-z","selected":"Apa-z","sephoraImage":"Bpa-z","unavailable":"Cpa-z","image":"Dpa-z"};